import React, {Component} from 'react';
import ArchivContainer from "../../utils/ArchivContainer";
import StaticVideoFunctions from "../../utils/StaticVideoFunctions";
import Job from "../../utils/Job";
import PropTypes from "prop-types";

class VideoCategoryContainer extends Component {

    static propTypes = {
        videoSource: PropTypes.string.isRequired,
        categoryList: PropTypes.object.isRequired,
        handleStateChange: PropTypes.func.isRequired,
        updateVideoCategories: PropTypes.func.isRequired,
    };

    constructor(props) {

        super(props);

        this.state = {};

        this.userRightSection = 'VideoCategory';
        this.contentCases = {
            'ok': null,
            'locked': 'Category is locked!',
            'expired': 'Permission expired!',
            'soon': 'Coming soon.',
        };

        this.translate = this.props.baseData.translate;

        this.updateVideoCategoryListJob = new Job(this.updateVideoCategoryList.bind(this), 10000);

    }

    componentWillMount() {

        this.updateVideoCategoryListJob.start(true);

    }

    componentWillUnmount() {

        this.updateVideoCategoryListJob.stop();

    }

    updateVideoCategoryList() {

        this.props.updateVideoCategories();

    }

    navigate(event, linkTo) {

        if (this.props.baseData.pageNavigation) {
            event.preventDefault();

            this.props.baseData.pageNavigation(linkTo);
        }

        return null;

    }

    getStatusCase(categoryId) {

        let statusCase = 'ok';

        if (this.props.videoSource !== 'YouTube') {
            statusCase = this.props.handleStatusCase(this.userRightSection, categoryId);
        }

        return statusCase;

    }

    renderCategories() {

        const videoSource = this.props.videoSource;
        const categories = this.props.categoryList;
        if (typeof categories !== 'undefined') {
            if (typeof categories['videoCategoryList'] !== 'undefined') {
                if (typeof categories['videoCategoryList']['category-' + videoSource] !== 'undefined') {
                    if (categories['videoCategoryList']['category-' + videoSource].length > 0) {
                        return categories['videoCategoryList']['category-' + videoSource].map(
                            (category) => <ArchivContainer
                                            key={category.categoryId}
                                            archivId={category.categoryId}
                                            classes="videoHover col-lg-2"
                                            title={category.categoryName}
                                            sub={category.categoryVideos + ' ' + ((category.categoryVideos > 1) ? this.translate('videos') : this.translate('video'))}
                                            content={this.contentCases[this.getStatusCase(category.categoryId)]}
                                            status={this.getStatusCase(category.categoryId)}
                                            backgroundImage={StaticVideoFunctions.getBackgroundImage(category.categoryImageId, this.props.videoSource)}
                                            handleNavigation={this.props.baseData.handleNavigation}
                                            handleStateChange={this.props.handleStateChange}
                                            onClick={this.props.onClick}
                            />
                        );
                    }
                }
            }
        }

        return this.translate('noCategoriesFound');

    }

    render() {

        const renderCategories = this.renderCategories();

        return (
            <div className="VideoCategoryContainer">
                <nav>
                    <h1>{this.translate('videoCategory')}</h1>
                </nav>

                <div className="archivArea">
                    <div className="clearfix">
                        {renderCategories}
                    </div>
                </div>

                {/*<div className="bottomLinks clearfix">
                    <a className="prewLink" onClick={(e) => this.navigate(e, 'video')}>{this.translate('backToOverview')}</a>
                </div>*/}
            </div>
        );

    }

}

export default VideoCategoryContainer;